import React from 'react'
import { FinancingCallbackStatusWrapper } from '../FinancingCallbackStatusWrapper'
import { messages } from './messages'

export const FinancingCallbackSuccess = () => {
  return <FinancingCallbackStatusWrapper icon="success" title={messages.title} subtitle={messages.subtitle} />
}
